import { useEffect, useRef, useState } from 'react';
import axios from "axios";
import moment from 'moment';
import { toast } from 'react-toastify';
import _ from 'lodash';

import consts from "../libs/consts";

import * as APIS from "./service";

import SecureStore from "react-secure-storage";

import { useLang } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";

export const regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/; // 휴대폰번호
export const regEmail = /^[^\sㄱ-ㅎㅏ-ㅣ가-힣]*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/; // 이메일
export const regEmail2 = new RegExp(/^[a-zA-Z0-9+-_.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/); // 이메일
export const regPassword = new RegExp(/^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[@$!%*#?&])[A-Za-z0-9@$!%*#?&]{8,15}$/); // 비밀번호
export const regNick = new RegExp(/^[ㄱ-ㅎ가-힣a-zA-Z0-9]{2,10}$/); // 닉네임


export const patternNum = /[0-9]/;	// 숫자 
export const patternEng = /[a-zA-Z]/;	// 영문 
export const patternSpc = /[\"\'\[\].,;-=~!@#$%^&*()_+|<>?:{}/~`|•√π÷×¶∆£¢€¥^°=\s]/; // 특수문자
export const patternUrl = /^http[s]?:\/\/([\S]{3,})/i; // URL

export const patternSpcInstar = /[^0-9a-zA-Z._]+/g; // 인스타용 허용글자
export const patternNick = /[^0-9a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣]+/g; // 닉네임용 허용글자
export const patternBrand = /[^0-9a-zA-Zㄱ-ㅎㅏ-ㅣ가-힣.,;-=~!@#$%^&*()_+|<>?:{}/~`\s]+/g; // 브랜드이름, 상호명용 허용글자
export const patternId = /[^0-9a-zA-Z]+/g; // 아이디용 허용글자


export const patternFloat = /^\d*[.]\d*$/; //소수점 한개만
export const patternCoord = /^-?(([-+]?)([\d]{1,3})((\.{1})(\d+))?)/; // 좌표


export const regInstargram = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/; // 이메일

export const patternKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; // 한글체크


export const regFileDoc = /(.*?)\.(jpg|jpeg|png|gif|bmp|svg|pdf|ai|psd|xls|xlsx|ppt|pptx|pem|zip|hwp|txt|doc|docx|mp4)$/; // 문서파일 가능한 확장자
export const regFileImage = /(.*?)\.(bmp|jpeg|jpg|png|tiff|tif)$/; // 이미지파일 가능한 확장자
export const regFileVideo = /(.*?)\.(mp4|mov|wmv|avi)$/; // 비디오파일 가능한 확장자
export const regFilePdf = /(.*?)\.(pdf)$/; // PDF파일 가능한 확장자
export const regFileExcel = /(.*?)\.(xlsx|csv)$/; // 엑셀 파일 가능한 확장자

export const hpHypen = (str) => {
    if (!str) return;

    return str.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3");
};

export const randomNumberLength = (length = 8) => {
    let randNum = _.random(99999999)
    return _.padStart(randNum, length, "0");
}
export const randomNumberCreate = ({ start = 1, end = 10 }) => {
    return Math.floor(Math.random() * (end + 1)) + start;
}

export const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        // 0부터 i까지의 무작위 인덱스를 선택합니다.
        const j = Math.floor(Math.random() * (i + 1));

        // 배열의 i번째 요소와 j번째 요소를 교환합니다.
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

export const numFormat = (num, cut = 1) => {
    if (num) {
        if (cut) num = Math.floor(num / cut) * cut; // 1000 = 백원단위 절삭
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
        return 0;
    }
};

export const patternNickFunc = (nick) => {
    /**
        1. 한글 최소 2글자 이상 최대 8글자 제한
        2. 영문 최소 2글자 이상 최대 15글자 제한
        3. 한글 + 영문 + 숫자 혼용 최대 15글자 제한
        4. 숫자만 사용 최대 8글자 제한
        5. 자음,모음,특수기호 허용 x
    */

    let regx = /[^0-9a-zA-Z가-힣]+/g; // 모음과 자음은 제외

    if (regx.test(nick) || nick.length < 2 || nick.length > 15) return true;

    let regxKor = /[가-힣]/; // 한글
    let regxEng = /[a-zA-Z]/; // 영어
    let regxNum = /[0-9]/; // 숫자

    let korCheck = regxKor.test(nick);
    let engCheck = regxEng.test(nick);
    let numCheck = regxNum.test(nick);

    // 영어만 작성한경우
    if ((!korCheck && engCheck && !numCheck)) {
        return nick.length > 15 ? true : false;
    }

    // 나머지 
    return nick.length > 8 ? true : false;

}

export const regPasswordFunc = (pw) => {
    return ((pw.length > 7 && pw.length < 16) && (patternNum.test(pw) && patternSpc.test(pw) && patternEng.test(pw)))
}

export const speak = (text, opt_prop, onEndFunc) => {

    const synth = window.speechSynthesis;

    if (typeof SpeechSynthesisUtterance === "undefined" || typeof window.speechSynthesis === "undefined") {
        alert("이 브라우저는 음성 합성을 지원하지 않습니다.")
        return
    }

    const voices = synth.getVoices();

    synth.cancel(); // 현재 읽고있다면 초기화

    const prop = opt_prop || {};

    const speechMsg = new SpeechSynthesisUtterance();
    speechMsg.rate = prop.rate || 1 // 속도: 0.1 ~ 10      
    speechMsg.pitch = prop.pitch || 1 // 음높이: 0 ~ 2
    speechMsg.lang = prop.lang || "ko-KR"
    speechMsg.text = text

    // SpeechSynthesisUtterance에 저장된 내용을 바탕으로 음성합성 실행
    synth.speak(speechMsg);

    speechMsg.onend = function () {
        onEndFunc();
    }
}

export const speakEnd = (text, opt_prop) => {
    const synth = window.speechSynthesis;
    synth.cancel();
}


export const useInterval = (callback, delay) => {
    const savedCallback = useRef()

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback
    }, [callback])

    // Set up the interval.
    useEffect(() => {
        const tick = () => {
            const { current } = savedCallback

            if (current !== undefined && current !== null) {
                current()
            }
        }
        if (delay !== null) {
            const id = setInterval(tick, delay)
            return () => clearInterval(id)
        }
        return () => { }
    }, [delay])
}


export const findJson = (option, idx) => {
    if (!option) return '';

    return option?.find(item => item?.idx === idx)?.title;
}

export const findJsonCl = (object, val) => {
    let title = "";

    object.forEach((one, index) => {
        if ((one.idx * 1) === (val * 1)) {
            title = one.cl;
        }
    })
    return title;
};

export const findJsonNum = (object, val) => {
    let title = 0;

    object.forEach((one, index) => {
        if ((one.idx * 1) === (val * 1)) {
            title = one.num;
        }
    })
    return title;
};

export const findJsonKey = (object, val, key) => {
    let title = 0;

    object.forEach((one, index) => {
        if ((one.idx * 1) === (val * 1)) {
            title = one[key];
        }
    })
    return title;
};


export const findArrInclues = (object, val, keyText) => {
    let chk = false;

    object.forEach((one, index) => {
        console.log(one);
        console.log(val);
        if (!keyText) {
            if ((one * 1) === (val * 1)) {
                chk = true;
                return;
            }
        } else {
            if ((one[keyText] * 1) === (val * 1)) {
                chk = true;
                return;
            }
        }

    })
    return chk;
};

export const getFileName = (url) => {

    let urls = url.split("/");
    return urls[urls.length - 1];
};

export const goLink = (navigate, route, state) => {
    console.log(state);
    navigate(route, { state: state });

};

export const clickImgS3 = (imgsrc) => {
    window.open(consts.s3url + imgsrc, "", "width=600px, height=600px");
};
export const clickDownS3 = (urls, fileName = "") => {

    let sender = {
        urls: urls,
        fileName
    };

    APIS.post('/admin/setting/getS3Url', sender).then(({ data }) => {
        window.open(data);
    }).catch((e) => {
        toast.error(e.response.data);
    });

    // window.open(consts.s3url + imgsrc);
};

export const clickImg = (imgsrc) => {
    var imageWin = new Image();
    imageWin = window.open("", "", "");
    imageWin.document.write("<html><body style='margin:0'>");
    imageWin.document.write("<img src='" + imgsrc + "' border=0 style='width: 100%; height: 100%; object-fit: contain;'>");
    imageWin.document.write("</body><html>");
};

export const clickDown = (url, mime = "", name = "") => {

    if (mime === 'base') {
        var link = document.createElement("a");
        link.download = name;
        link.href = url;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
    } else {
        window.open(url, "", "");
    }

};

export const allSetValue = (i, e, val, list) => {
    console.log(i);
    console.log(val);
    console.log(e.target.name);

    // let newFormValues = [...list];
    // newFormValues[i][e.target.name] = val;

    const newFormValues = list.map((item, index) => {
        if (index !== i) {
            return item
        }
        return {
            ...item,
            [e.target.name]: val,
        }
    })

    return newFormValues;
}


export const allSetValueObject = (e, val, list) => {
    console.log(e);
    console.log(val);
    console.log(list);

    return {
        ...list,
        [e.target.name]: val,
    }

}

export const allSetValueAppend = (i, e, val, list) => {
    console.log(i);
    console.log(val);
    console.log(e.target.name);

    // let newFormValues = [...list];
    // newFormValues[i][e.target.name] = [...newFormValues[i][e.target.name], ...val];

    const newFormValues = list.map((item, index) => {
        if (index !== i) {
            return item
        }
        return {
            ...item,
            [e.target.name]: [...item[e.target.name], ...val],
        }
    })


    return newFormValues;
}

export const allSetValueMultiAppend = (i, e, ee, val, val2, list) => {
    console.log(i);
    console.log(val);
    console.log(e.target.name);

    // let newFormValues = [...list];
    // newFormValues[i][e.target.name] = [...newFormValues[i][e.target.name], ...val];

    const newFormValues = list.map((item, index) => {
        if (index !== i) {
            return item
        }
        return {
            ...item,
            [e.target.name]: [...item[e.target.name], ...val],
            [ee.target.name]: [...item[ee.target.name], ...val2],
        }
    })

    return newFormValues;
}

export const allSetValueMulti = (i, e, ee, val, val2, list) => {
    console.log(i);
    console.log(val);
    console.log(e);

    const newFormValues = list.map((item, index) => {
        if (index !== i) {
            return item
        }
        return {
            ...item,
            [e.target.name]: val,
            [ee.target.name]: val2,
        }
    })

    // let newFormValues = [...caseAll];
    // newFormValues[i][e.target.name] = val;
    return newFormValues;
}

export const allSetDeletePhoto = (i, e, val, list) => {
    console.log(i);
    let newFormValues = [...list];
    newFormValues[i][e.target.name] = val;

    return newFormValues;
}


export const changeArrayOrder = (list, targetIdx, moveValue) => {
    // 배열값이 없는 경우 나가기

    console.log(targetIdx, moveValue);
    if (list.length < 0) return list;

    // 이동할 index 값을 변수에 선언
    const newPosition = targetIdx + moveValue;

    // 이동할 값이 0보다 작거나 최대값을 벗어나는 경우 종료
    if (newPosition < 0 || newPosition >= list.length) return list;

    // 임의의 변수를 하나 만들고 배열 값 저장
    const tempList = JSON.parse(JSON.stringify(list));

    // 옮길 대상을 target 변수에 저장하기
    const target = tempList.splice(targetIdx, 1)[0];

    // 새로운 위치에 옮길 대상을 추가하기
    tempList.splice(newPosition, 0, target);
    return tempList;
}

export const dataProcessFunc = (data) => {

    let list = data;

    if (list?.length > 0) {
        return list?.map((x, i) => {
            // console.log('list i', i);

            let sdate = x.list?.[0]?.sdate || '0000-00-00';
            let edate = x.list?.[0]?.edate || '0000-00-00';
            let total_per = 0;

            let list_2 = x.list.map((xx, ii) => {
                if (!moment(sdate).isBefore(xx.sdate)) {
                    sdate = xx.sdate;
                }
                if (moment(edate).isBefore(xx.edate)) {
                    edate = xx.edate;
                }

                let total_day = moment.duration(moment(xx.edate).diff(moment(xx.sdate))).asDays();
                let now_day = Math.floor(moment.duration(moment().diff(moment(xx.sdate))).asDays());

                let data_per = Math.round((now_day / total_day) * 100);

                let plan_per = data_per < 0 ? 0 : data_per <= 100 ? data_per : 100;

                total_per += xx.per * 1;

                return {
                    ...xx,
                    total_day: total_day,
                    now_day: now_day,
                    plan_per: plan_per
                }

            })

            let total_day = moment.duration(moment(edate).diff(moment(sdate))).asDays();
            let now_day = Math.floor(moment.duration(moment().diff(moment(sdate))).asDays());

            let all_data_per = Math.round((now_day / total_day) * 100);

            let plan_per = all_data_per < 0 ? 0 : all_data_per <= 100 ? all_data_per : 100;

            return {
                ...x,
                list: list_2,
                sdate: sdate,
                edate: edate,
                total_day: total_day,
                now_day: now_day,
                plan_per: plan_per,
                total_per: Math.round(total_per / x.list?.length)
            }
        })

    }

    return list;
}

export const adminAuth = (mbData) => {

    if (mbData?.level === 10) return true;

    return false;
};

export const workAuth = (mbData) => {
    if (mbData?.auth_work === 2 || mbData?.level === 10) return true;

    return false;
};

export const noteAuth = (mbData) => {

    if (mbData?.auth_note === 2 || mbData?.level === 10) return true;

    return false;
};

export const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


export const useAutosizeTextArea = (textAreaRef, value) => {
    useEffect(() => {
        if (textAreaRef) {
            // We need to reset the height momentarily to get the correct scrollHeight for the textarea
            textAreaRef.style.height = "0px";
            const scrollHeight = textAreaRef.scrollHeight;

            // We then set the height directly, outside of the render loop
            // Trying to set this with state or a ref will product an incorrect value.
            textAreaRef.style.height = scrollHeight + "px";
        }
    }, [textAreaRef, value]);
};

export const autolink = (text) => {

    if (text) {
        var regURL = new RegExp("(http|https|ftp|telnet|news|irc)://([-/.a-zA-Z0-9_~#%$?&=:200-377()]+)", "gi");
        text = text.replace(regURL, "<a className='link' href='$1://$2' target='_blank'>$1://$2</a>");
    }

    return text;
};

export const getMakerClass = (item) => {

    let makerClass = 'marker6';

    if (item?.item_H && item?.item_H !== '0' && item?.item_H !== 0) {
        makerClass = 'marker1';
        return makerClass;
    }
    if (item?.item_BN) {
        makerClass = 'marker2';
        return makerClass;
    }

    if (item?.item_K * 1 <= 5000) {
        makerClass = 'marker3';
        return makerClass;
    }
    if (item?.item_K * 1 <= 10000) {
        makerClass = 'marker4';
        return makerClass;
    }
    if (item?.item_K * 1 <= 20000) {
        makerClass = 'marker5';
        return makerClass;
    }

    return makerClass;
}

export const useWindowSize = () => {
    // Initialize state with undefined width/height so server and client renders match
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    });

    useEffect(() => {
        // Handler to call on window resize
        function handleResize() {
            // Set window width/height to state
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        }

        // Add event listener
        window.addEventListener("resize", handleResize);

        // Call handler right away so state gets updated with initial window size
        handleResize()

        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleResize);

    }, []);

    return windowSize
}


export const dataFormat = (colum, dataOri) => {
    let data = dataOri;
    if (!data) return '';

    /* format 변환 */
    if (colum?.format === 'int') {
        data = numFormat(Math.floor(data * 1));
    }
    if (colum?.formatDate) {
        if (data * 1 !== 0 && moment(data).isValid()) {
            data = moment(data).format(colum?.formatDate);
        }
    }
    /* format 변환 끝*/


    /* unit 검사 */
    if (colum?.unit) {
        data = data + '' + colum?.unit;
    }

    return data;
}



export const useDebounce = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);

        return () => {
            clearTimeout(timer);
        }; //value 변경 시점에 clearTimeout을 해줘야함.
    }, [value]);

    return debouncedValue;
};

export const pdfViewer = async (urls, fileName) => {

    let sender = {
        urls: urls,
        fileName: fileName
    }

    let signUrl = await APIS.post('/getS3Url', sender).then(({ data }) => {
        console.log('download', data);
        return data;
    }).catch((e) => {
        toast.error(
            e.response.data
            , consts.toastErrorOption
        );
        return false;
    })

    return signUrl;
};


export const clickDownS3FileName = (urls, fileName) => {

    let sender = {
        urls: urls,
        fileName: fileName
    }

    APIS.post('/getS3Url', sender).then(({ data }) => {
        console.log('download', data);

        const a = document.createElement('a');
        a.href = data;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
    }).catch((e) => {
        toast.error(
            e.response.data
            , consts.toastErrorOption
        );
    });

};

export const isJson = (str) => {
    try {
        var json = JSON.parse(str);
        return (typeof json === 'object');
    } catch (e) {
        return false;
    }
}

export const chunkFunc = (data = [], size = 1) => {
    const arr = [];

    for (let i = 0; i < data.length; i += size) {
        arr.push(data.slice(i, i + size));
    }

    return arr;
}

export const isMobile = () => {
    return /iPhone|iPad|iPod|Android/i.test(navigator?.userAgent);
};

export const animateCSS = ({
    element,
    animation,
    prefix = 'animate__',
    faster,
    show,
    hide
}) =>
    // We create a Promise and return it
    new Promise((resolve, reject) => {
        const animationName = `${prefix}${animation}`;
        const node = document.querySelector(element);
        if (!node) return;
        if (show) {
            node.style.display = show;
        }
        if (faster) {
            node.classList.add(`animate__faster`);
        }
        node.classList.add(`${prefix}animated`, animationName);

        // When the animation ends, we clean the classes and resolve the Promise
        function handleAnimationEnd(event) {
            event.stopPropagation();
            if (hide) {
                node.style.display = 'none';
            }
            node.classList.remove(`${prefix}animated`, animationName);
            resolve('Animation ended');
        }

        node.addEventListener('animationend', handleAnimationEnd, { once: true });
    });

export const errorMessage = ({ msgkey, code }) => {

    // const err = [500, 1000, ];
    const info = [1020];

    if (info.includes(code)) {
        toast.info(<LangText id={msgkey} />);
    } else {
        toast.error(<LangText id={msgkey} />);
    }

}

export const elapsedTime = (date, lang = "ko") => {
    console.log("🚀 ~ elapsedTime ~ date:", date)
    const start = new Date(date);
    const end = new Date();

    const seconds = Math.floor((end.getTime() - start.getTime()) / 1000);
    if (seconds < 60) return lang == "ko" ? '방금 전' : "just now";

    const minutes = seconds / 60;
    if (minutes < 60) return `${Math.floor(minutes)}${lang == "ko" ? "분 전" : " min ago"}`;

    const hours = minutes / 60;
    if (hours < 24) return `${Math.floor(hours)}${lang == "ko" ? "시간 전" : " hour ago"}`;

    const days = hours / 24;
    if (days < 365) return `${Math.floor(days)}${lang == "ko" ? "일 전" : " day ago"}`;

    return `${moment(start).format("YYYY.MM.DD HH:mm")}`;
};

export const getSlideValue = (config, value) => {
    const { min, max, step } = config;
    if (typeof min != "number"
        && typeof min != "number"
        && typeof min != "number") {
        return null
    }

    let valueList = []
    for (let i = min; i <= max; i += step) {
        valueList.push(Math.round(i * 100) / 100);
    }
    let cutValue = 100 / valueList.length;
    let resultIndex = Math.floor(value / cutValue);
    let result = valueList[resultIndex]

    if (resultIndex > valueList.length - 1) {
        result = valueList[valueList.length - 1]
    }

    return result
}

export const toSlideValue = (config, value) => {
    const { min, max, step } = config;
    if (typeof min != "number"
        && typeof min != "number"
        && typeof min != "number") {
        return null
    }

    let valueList = []
    for (let i = min; i <= max; i += step) {
        valueList.push(Math.round(i * 10) / 10);
    }

    let valueIndx = valueList.indexOf(value)
    let result = Math.ceil(valueIndx / valueList.length * 100);

    return result
}


export async function loadImage(src) {

    const urlToFile = async (url) => await fetch(url).then((res) => res.blob())

    const blobToBase64 = (blob) => {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        return new Promise((rs, rj) => {
            reader.onloadend = () => {
                rs(reader.result)
            }
            reader.onerror = rj
        })
    }

    return new Promise((resolve) => {
        const img = new Image()
        img.src = src
        img.crossOrigin = "Anonymous"
        img.onload = async () => {
            const blob = await urlToFile(src)
            const base64 = await blobToBase64(blob)
            let dotlist = src.split(".");
            resolve({ base: base64, ext: dotlist[dotlist.length - 1] })
        }
    })
}